module.exports = __webpack_public_path__ + "media/5.daf8c9d2.wav";